import ReadOnlyEditSplitter from '../../core/components/FeatureViews/ReadOnlyEditSplitter'
import EditFeatureDispatcherContainer from './EditFeatureDispatcherContainer'
import ReadOnlyDispatcherContainer from './ReadOnlyDispatcherContainer'
import * as React from 'react'

class AppReadOnlyEditSplitter extends ReadOnlyEditSplitter {
  getEditingComponent() {
    return (
      <EditFeatureDispatcherContainer
        layerId={this.props.layerInfo.url}
        feature={this.props.feature}
        editAgain={this.props.editAgain}
        //Parents know better:
        buttonsClassname={this.props.buttonsClassname}
        onCancel={() => {
          this.setState({...this.state, editing: !this.state.editing})
        }}
        onAfterDelete={() => {
          this.props.onAfterDelete && this.props.onAfterDelete()
        }}
        onAfterSave={g => {
          this.props.onAfterSave && this.props.onAfterSave(g)
        }}
        saveControlsTop={this.props.saveControlsTop}
        hideSave={this.props.hideSave}
        hideDelete={this.props.hideDelete}
        hideCancel={this.props.hideCancel}
        style={this.props.style}
      />
    )
  }
  getReadOnlyComponent() {
    return <ReadOnlyDispatcherContainer layerId={this.props.layerInfo.url} feature={this.props.feature} />
  }
}

export default AppReadOnlyEditSplitter
